import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';
import { Text } from '@myrealtrip/web-ui';

import { AGE_NOTIFICATION_MESSAGES } from '~constants/pointToPointTicket';

const TravelerNotificationList = () => {
  const theme = useTheme();

  return (
    <>
      <HighlightNotice>
        <Text typography="paragraphNormal14">나이는 탑승일 기준으로 선택해주세요.</Text>
        <ExampleTable>
          <thead>
            <tr>
              <th>현재 나이</th>
              <th>생일</th>
              <th>탑승일</th>
              <th>입력할 나이</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>만 25세</td>
              <td>1월 31일</td>
              <td>2월 1일</td>
              <td>
                <strong>만 25세</strong>
              </td>
            </tr>
            <tr>
              <td>만 25세</td>
              <td>2월 1일</td>
              <td>2월 1일</td>
              <td>
                <strong>만 26세</strong>
              </td>
            </tr>
            <tr>
              <td>만 25세</td>
              <td>2월 1일</td>
              <td>2월 2일</td>
              <td>
                <strong>만 26세</strong>
              </td>
            </tr>
          </tbody>
        </ExampleTable>
        <Text typography="paragraphNormal14">
          입력한 나이를 기준으로 승객 유형(성인, 청소년, 시니어)이 자동으로 설정되며, 철도사마다
          승객 유형에 따른 나이 기준이 다를 수 있어요.
        </Text>
      </HighlightNotice>

      <AgeNotifications>
        {AGE_NOTIFICATION_MESSAGES.map((message, index) => (
          <AgeNotification key={index}>
            <Text typography="paragraphNormal14" color={theme.colors.gray.s600}>
              {message}
            </Text>
          </AgeNotification>
        ))}
      </AgeNotifications>
    </>
  );
};

const AgeNotifications = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  margin: 20px 16px 16px;
  background: ${({ theme: { palettes } }) => palettes.gray[50]};
  border-radius: 12px;

  ${media.minMobile} {
    margin: 16px;
  }
`;

const AgeNotification = styled.li`
  position: relative;
  display: flex;
  justify-content: flex-start;
  gap: 6px;
  padding-left: 8px;

  &::before {
    content: '';
    position: absolute;
    top: calc(19px / 2);
    left: 0;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: ${({ theme: { palettes } }) => palettes.gray[600]};
    margin-right: 6px;
  }
`;

const HighlightNotice = styled.div`
  margin: 8px 0 0;
  padding: 0 20px;
  color: ${({ theme }) => theme.colors.yellow.s700};
  word-break: keep-all;
`;

const ExampleTable = styled.table`
  width: 100%;
  margin: 8px 0;
  border-collapse: collapse;
  font-size: 12px;

  th,
  td {
    padding: 6px 4px;
    text-align: center;
    border: 1px solid ${({ theme }) => theme.colors.yellow.s700}40;
  }

  th {
    background: ${({ theme }) => theme.colors.yellow.s700}20;
    font-weight: 600;
  }

  td strong {
    font-weight: 700;
  }
`;

export default TravelerNotificationList;
